export const bundlesIDs = {
    bundle1: 'b855fd16-de34-41a0-9206-3f770c5c936c',
    bundle2: 'fd3296d5-ecba-4379-ba26-b427530788da',
    bundle3: '8af00590-14d6-49bc-9cfd-065f3f34dc4c',
    bundle4: '2496b4fa-d4a8-4ee0-8fac-fa08c48dc475',
    bundle5: '0e02335c-6d5d-47c8-b316-a42a727fd7b4',
    bundle6: 'bb58dd36-f2a1-4f33-a580-ad72aa05223e'
}